import React from 'react';
import Rest from 'tools/rest';
import { Modal, Tag } from 'antd';
import CameraForm from './components/cameraForm';

class CameraUpdate extends React.Component {
  state = {
    camera: {},
    agreements: [],
    cameraLoaded: false,
    sesameExists: null,
  };

  loadCamera() {
    const id = this.props.selected_camera.id;
    Rest.get(`api/v1/cameras/${id}.json`).then((respons) => {
      this.setState({
        camera: respons.data.camera,
        cameraLoaded: true,
        agreements: respons.data.agreements,
      });
    });
  }

  componentDidMount() {
    this.loadCamera();
  }

  handleClose = () => {
    this.props.dataRelevanceChange();
    this.props.closer();
  };

  renderSesameBadge() {
    const { sesameExists } = this.state;
    if (sesameExists === null) return null;
    return sesameExists ? (
      <Tag color="green" style={{ marginLeft: 12 }}>Есть в Sesame</Tag>
    ) : (
      <Tag color="red" style={{ marginLeft: 12 }}>Нет в Sesame</Tag>
    );
  }

  render() {
    const { camera, agreements, cameraLoaded } = this.state;
    return (
      <Modal
        title={
          <span>
            {`Паспорт камеры № ${camera.id} - ${camera.name}`}
            {this.renderSesameBadge()}
          </span>
        }
        visible={this.props.visible}
        onCancel={this.handleClose}
        onOk={this.handleClose}
        width="90%"
        footer={null}
      >
        {cameraLoaded && (
          <CameraForm
            agreements={agreements}
            camera={camera}
            onSesameStatusChange={(exists) => this.setState({ sesameExists: exists })}
          />
        )}
      </Modal>
    );
  }
}

export default CameraUpdate;
